module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-form-inputs"
  }, [_c('div', {
    staticClass: "u-d-flex u-flex-center u-r-flex-wrap"
  }, [_c('h2', {
    staticClass: "u-centre chart u-margin-bottom-20 u-r-flex-1-0-100"
  }, [_vm._v("\n            Analyse Claims by Claims Handler\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "fee-earner",
    on: {
      "click": _vm.openModal
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "info",
      "tooltip-text": "Click to see details of the different options",
      "side": "left",
      "text-width": "200"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-compare-reserve__fee-earner-chart-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.compareType),
      expression: "compareType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.compareType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Total Difference"
    }
  }, [_vm._v("Total Difference")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Average Difference"
    }
  }, [_vm._v("Average Difference")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Maximum Difference"
    }
  }, [_vm._v("Maximum Difference")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Number of Claims"
    }
  }, [_vm._v("Number of Claims")])])]), _vm._v(" "), (_vm.show && _vm.theCurrentWidth >= 600) ? _c('bar-chart', {
    attrs: {
      "chart-data": _vm.currentChartData,
      "options": _vm.chartOptions,
      "height": 200
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theCurrentWidth < 600) ? _c('table', {
    staticClass: "a-table"
  }, [_c('th', [_vm._v("Fee Earner")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.compareType))]), _vm._v(" "), _vm._l((_vm.currentChartData.labels), function(info, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.currentChartData.labels[index]))]), _vm._v(" "), (_vm.compareType !== 'Number of Claims') ? _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.currentChartData.datasets[0].data[index])))]) : _c('td', [_vm._v(_vm._s(_vm.currentChartData.datasets[0].data[index]))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "feinfo",
      "no-default-button": "true"
    }
  }, [_c('h2', [_vm._v("Different options for comparing Claims Handlers.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Total Difference")])]), _vm._v(" "), _c('p', [_vm._v("The total difference from '" + _vm._s(_vm.fromLabel) + "' to '" + _vm._s(_vm.toLabel) + "' grouped by Claims Handler for all the claims\n            matching your filter criteria.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Average Difference")])]), _vm._v(" "), _c('p', [_vm._v("The average difference from '" + _vm._s(_vm.fromLabel) + "' to '" + _vm._s(_vm.toLabel) + "' for each Claims Handler for all the claims\n            matching your filter criteria.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Maximum Difference")])]), _vm._v(" "), _c('p', [_vm._v("For each Claims Handler the case that has the maximum difference from '" + _vm._s(_vm.fromLabel) + "' to '" + _vm._s(_vm.toLabel) + "'\n            matching your filter criteria.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Total Claims")])]), _vm._v(" "), _c('p', [_vm._v("For each Claims Handler the total number of claims that match your filter criteria for each Claims Handler.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("NOTE: Any Claims Handler that does not have a result is omitted.")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-569dc4c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/components/FeeEarnerChart.vue
// module id = 1698
// module chunks = 0